import {TalentSurvey} from '../../../../../features/talent/types';
import {generateFetchOptions} from '../../index';

// PUT /api/v1/talent_surveys/:id/answers
export async function complete(talentSurvey: TalentSurvey): Promise<Response> {
  const answers = talentSurvey.answers.map((answer) => {
    return {
      question_id: answer.questionId,
      answer: answer.value,
    };
  });

  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/talent_surveys/${talentSurvey.id}/answers`,
    generateFetchOptions({
      method: 'PUT',
      isProtected: false,
      body: {
        started_at: talentSurvey.startedAt,
        talent_survey_answers: answers,
      },
    })
  );
}
